/*=================================================================================================================
File Name: appinit.service.ts
Description: This service is responsible for
Note: Carefully to while doing modification.

Created By: Sangram, Creation Date: 07th May 2021, Modified By: Sangram, Modification Date: 07th May 2021
===================================================================================================================*/

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError, shareReplay } from 'rxjs/operators';
import { CONSTANTS_DATA, CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { environment } from '@fitness-force/environments';
import { AppErrors, NotFoundError } from '@fitness-force/models';;

@Injectable({
  providedIn: 'root',
})
export class AppInitService {
  private  http = inject(HttpClient);

  getSubDomain: any;
  getStoredDomain: any;
  isResponse = '';

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  getCompanyInformation(): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.OPEN_API.GET_COMPANY_SUBDOMAIN.replace('{subdomain}', window.location.hostname);

    return this.http.get(url, { headers: this.httpOptions.headers }).pipe(
      map((res) => {
        return res;
      }),
      shareReplay(1),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getAuthCompanyInformation(companyId: number): Observable<any> {
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_COMPANY_BY_ID
          .replace('{company_id}', companyId.toString()),
        {
          headers: this.httpOptions.headers,
        }
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          } else {
            return false;
          }
        }),
        shareReplay(1),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getCompanyByUuid(uuid: string): Observable<any> {
    return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_COMPANY_BY_UUID
      .replace('{uuid}', uuid), { headers: this.httpOptions.headers })
    .pipe(
      map((res: any) => {
        return res;
      }),
      shareReplay(1),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getSourceStats(): Observable<any> {
    const url= environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_CLIENT_SOURCE_STATS + '?channel=Other&limit=100';
    return this.http.get(url, { headers: this.httpOptions.headers }).pipe(
      map((res: any) => {
        return res;
      }),
      shareReplay(1),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getBlogData(): Observable<any> {
    return this.http
      .get(CONST_URL_SEGEMENTS.BLOG_API, {
        headers: new HttpHeaders()
          .set('Content-Type', 'text/xml')
          .append('Access-Control-Allow-Methods', 'GET')
          .append('Access-Control-Allow-Origin', '*')
          .append(
            'Access-Control-Allow-Headers',
            'Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method'
          ),
        responseType: 'text',
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  parseLanguage(lang: string) {
    return CONSTANTS_DATA.ALL_LANGUAGES.find((l) => l.LANG_CODE === lang);
  }
}
